import { z } from 'zod';
import { IMPORT_KINDS, IMPORT_STATUSES } from '../imports.ts';
import { SOURCE_TYPES } from '../recipe.ts';

/** `POST /api/imports`: a link, pasted text, or 1–5 uploaded screenshots. */
export const importRequestSchema = z
  .object({
    url: z.string().trim().min(1).max(2000).optional(),
    text: z.string().trim().min(1).max(50_000).optional(),
    imageIds: z.array(z.uuid()).min(1).max(5).optional(),
    /** Import again even if this source is already a recipe. */
    force: z.boolean().default(false),
  })
  .refine((r) => [r.url, r.text, r.imageIds].filter((v) => v !== undefined).length === 1, {
    message: 'Send exactly one of url, text or imageIds',
  });
export type ImportRequest = z.input<typeof importRequestSchema>;

export const importJobSchema = z.object({
  id: z.uuid(),
  kind: z.enum(IMPORT_KINDS),
  sourceType: z.enum(SOURCE_TYPES),
  status: z.enum(IMPORT_STATUSES),
  url: z.string().nullable(),
  title: z.string().nullable(),
  error: z.string().nullable(),
  errorKind: z.string().nullable(),
  recipeId: z.uuid().nullable(),
  recipeReviewed: z.boolean().nullable(),
  costUsd: z.number(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});
export type ImportJob = z.infer<typeof importJobSchema>;
export const importListSchema = z.object({ imports: z.array(importJobSchema) });

export const importCreatedSchema = z.discriminatedUnion('duplicate', [
  z.object({ duplicate: z.literal(false), job: importJobSchema }),
  z.object({
    duplicate: z.literal(true),
    recipeId: z.uuid(),
    title: z.string(),
  }),
]);
export type ImportCreated = z.infer<typeof importCreatedSchema>;
